import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { SvgLoading } from 'sarsaparilla';

const propTypes = {
  isOpen: PropTypes.bool,
  message: PropTypes.string,
};

class Loading extends React.Component {
  message(message) {
    if (!message) {
      return null;
    }

    return <div id="loading-message">{message}</div>;
  }

  render() {
    return (
      <Modal
        aria={{
          labelledby: 'loading-message',
        }}
        isOpen={this.props.isOpen}
        role="complementary"
        className="wrapper no-select"
        contentLabel="No Content Modal"
        style={{ overlay: { backgroundColor: 'transparent' } }}
      >
        <div className="loading-modal">
          {this.message(this.props.message)}
          <SvgLoading size="larger" />
        </div>
      </Modal>
    );
  }
}

Loading.propTypes = propTypes;

Modal.setAppElement('#recApp');

const mapStateToProps = (state) => {
  return {
    message: state.loading.message,
    isOpen: state.loading.display,
  };
};

export default connect(mapStateToProps)(Loading);
